<template>
    <div></div>
</template>

<script lang="ts" setup>
import IUser from '@/types/Members/IUser';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { computed } from 'vue';
import Intercom from '@intercom/messenger-js-sdk';

const globalProps = computed(() => usePage<ITopolPageProps>().props);
const user = computed(() => globalProps.value.user as IUser);
const userHash = ref();
const subscriptionPlan = ref();
const earliestSubscriptionMonthsPaid = ref();
const anyTeamSubscription = ref();
const appId = ref('q5dsh338');

const loadIntercom = () => {
  if (!user.value) {
    return;
  }

  Intercom({
    app_id: appId.value,
    name: user.value.name,
    email: user.value.email,
    user_hash: userHash.value, 
    external_id: user.value.id,
    subscription_plan: subscriptionPlan.value,
    earliest_subscription_months_paid: earliestSubscriptionMonthsPaid.value,
    any_team_subscription: anyTeamSubscription.value,
    user_kiosk_url: "https://app.topol.io/kiosk/users/" + user.value.id + "/activity",
})
};

const loadData = async () => {
    try {
        const response = await axios.get(route('intercom-data.index'));

        if (!response.data) {
            return;
        }

        userHash.value = response.data.user_hash;
        subscriptionPlan.value = response.data.subscription_plan;
        earliestSubscriptionMonthsPaid.value =
            response.data.earliest_subscription_months_paid;
        anyTeamSubscription.value = response.data.any_team_subscription;
    } catch (error) {
        return;
    }
};

onMounted(async () => {
    await loadData();
    loadIntercom();
});

onUnmounted(() => {
    if (typeof window.Intercom === 'function') {
        window.Intercom('shutdown');
    }
});
</script>
